export const uploadFile = (firebase, values, name, callback) => {
  const file = values[name];
  const storageRef = firebase.storage().ref();
  const uploadTask = storageRef.child(`/${file.name}`).put(file);

  uploadTask.on('state_changed', null, null, () => {
    const downloadURL = uploadTask.snapshot.downloadURL;
    callback({ url: downloadURL, name: file.name });
  });
};



// WEBPACK FOOTER //
// ./src/modules/AddEntryModalButton/actions.js